import React, { useState, useEffect } from "react";
import { Modal, Select, Form, Button } from "antd";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import configureAppStore from "../../redux/store";
import { callApi } from "../../api/apiCaller";

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      if (recordData) {
        console.log("rrrrrrrrrrr", recordData.isFree);
        form.setFieldsValue({
          isFree: recordData?.isFree ? "Free" : "Paid",
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, recordData, form]);

  const token = configureAppStore.getState().userDataSlice.token;

  const handleSave = () => {
    form
      .validateFields()
      .then((values) => {
        const requestBody = {
          isFree: values.isFree === "Free", // If "Free" is selected, set isFree to true; otherwise, false
        };
        console.log("Request body", requestBody);

        const getRes = (res) => {
          if (res.status === 400) {
            if (
              res.message === "Trainer already exists, you can add only one."
            ) {
              RedNotify("A trainer already exists. You can only add one.");
              toggleModal();
            } else {
              RedNotify("Validation Error: " + res.message);
            }
          } else if (res.status === 200) {
            GreenNotify(
              recordData
                ? "User updated successfully."
                : "Trainer created successfully."
            );
            toggleModal();
          } else {
            RedNotify("An error occurred. Please try again later.");
          }
        };

        const apiCall = recordData
          ? callApi(
              "PATCH",
              `${routes.addFree}/${recordData._id}`,
              requestBody,
              setIsLoading,
              getRes
            )
          : callApi(
              "POST",
              `${routes.createTrainer}`,
              requestBody,
              setIsLoading,
              getRes
            );

        apiCall.catch((error) => {
          console.error("API call error", error);
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        });
      })
      .catch((errorInfo) => {
        console.error("Validation Error:", errorInfo);
        RedNotify("Please ensure all fields are filled out correctly.");
      });
  };

  return (
    <Modal
      title={recordData ? "Update User" : "Create Trainer"}
      visible={visible}
      onCancel={toggleModal}
      footer={[
        <Button key="cancel" onClick={toggleModal}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          loading={isLoading}
        >
          {recordData ? "Update" : "Save"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="isFree"
          rules={[{ required: true, message: "Please select an option" }]}
        >
          <Select placeholder="Select an option">
            <Select.Option value="Free">Free</Select.Option>
            <Select.Option value="Paid">Paid</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddVideo;
